/* eslint-disable default-param-last */
//  const HYDRATE = "__NEXT_REDUX_WRAPPER_HYDRATE__";
const HYDRATE = "__NEXT_REDUX_WRAPPER_HYDRATE__";

export const types = {
  /* CONTEXT */
  SET_CONTEXT_DATA: 'MAIN/SET_CONTEXT_DATA',
  SET_CUSTO_PARAMS: 'MAIN/SET_CUSTO_PARAMS',
  SET_CP_PARAMS: 'MAIN/SET_CP_PARAMS',
  SET_ZONE_REFRESH_FLAG: 'MAIN/SET_ZONE_REFRESH_FLAG',
  SET_CP_MODAL_CLOSED: 'MAIN/SET_CP_MODAL_CLOSED',
  CHECK_CP_AND_SET_ZONES: 'MAIN/CHECK_CP_AND_SET_ZONES',
  SET_CHECKED_CP_BY_API: 'MAIN/SET_CHECKED_CP_BY_API',
  SET_USER_PQ_INFO: 'MAIN/SET_USER_PQ_INFO',
  /* EDIT MODE */
  SET_EDIT_MODE: 'MAIN/SET_EDIT_MODE'
};

export const actions = {
  /* CONTEXT */
  setCpModalClosed: (flag) => ({ type: types.SET_CP_MODAL_CLOSED, flag }),
  setZoneRefreshFlag: (flag) => ({ type: types.SET_ZONE_REFRESH_FLAG, flag }),
  setCpParams: (data) => ({ type: types.SET_CP_PARAMS, data }),
  setContextData: (data) => ({ type: types.SET_CONTEXT_DATA, payload: data }),
  checkCPAndSetZones: (data) => ({ type: types.CHECK_CP_AND_SET_ZONES, data }),
  setCheckedCPByApi: (flag) => ({ type: types.SET_CHECKED_CP_BY_API, flag }),
  setUserPqInfo: (data) => ({ type: types.SET_USER_PQ_INFO, data }),
  /* EDIT MODE */
  setEditMode: flag => ({ type: types.SET_EDIT_MODE, flag })
};
let context = {}
try {
  context = `${process.env.NEXT_PUBLIC_CONTEXT || '{}'}`;
  // console.log('context antes', context);
  context = JSON.parse(context);
} catch (err) {
  // console.log('context petó', context)
  console.error(err);
}

const initialState = {
  cp: "...",
  zone: "",
  refreshZone: false,
  cpModalClosed: true,
  // municipio seleccionado, por cliente
  municipio: "",
  // lista de posibles municipios bajo ese cp
  municipiosPosibles: null,
  context,
  logged: 0,
  checkedCpByApi: true,
  userPq: null, // cositas del parque del usuario 
  userFlags: null,  // ['soloBaf', 'tv-promo', 'caja de gambas']
  editMode: false,
};


function reducer(state = { ...initialState }, action) {
  switch (action.type) {
    case HYDRATE: {
      let { main } = action.payload;
      return {
        ...state,
        ...main,
      };
    }
    case types.SET_CHECKED_CP_BY_API: 
      return {
        ...state,
        checkedCpByApi: action.flag
      }
    // solo guardo, jamás deduzco nada
    case types.SET_CP_PARAMS: {
      let { refreshZone } = state;
      const  { municipio, cp, persist, zone, businessZones } = action.data;
      let municipiosPosibles = []
      if (businessZones) {
        municipiosPosibles = businessZones;
      }

      if(persist){
        import('@gerenciatd/next13.utils.secure.local-storage').then(module => {
          let secureStorage = module.default;
          secureStorage = new secureStorage();
          let currentPersisted = secureStorage.getItem('ts');
          if (currentPersisted && !currentPersisted.ts) {
            currentPersisted.ts = Date.now();
          }
          const modifiedPersisted = {
            ...currentPersisted,
            geo : {
              postalCode: cp,
              municipio,
              // businessZones: municipiosPosibles,
              zone,
            }
          }
          secureStorage.setItem('ts', modifiedPersisted)
        })
    }
    if (
      (zone && zone !== initialState.zone)
      && (state.zone !== initialState.zone)
      && zone !== state.zone
    ){
      refreshZone = true;
    }
      return {
        ...state,
        refreshZone,
        cp,
        zone,
        municipio,
        municipiosPosibles,
      }
    }
    case types.SET_USER_PQ_INFO: {
     
      return {
        ...state,
        userPq: action.data.userPq,
        userFlags: action.data.userFlags,
      }
    }

    case types.SET_CP_MODAL_CLOSED: {
      return {
        ...state,
        cpModalClosed: action.flag
      }
    }
    case types.SET_ZONE_REFRESH_FLAG:{
      return {
        ...state,
        refreshZone: action.flag,
      }
    }
    case types.SET_CONTEXT_DATA: {
      let newContext = {
        ...state.context,
        ...action.payload,
        environment: {
          ...state.context.environment,
          ...action.payload.environment,
        }
      }
      // full logado con idhash;
      let logged = (newContext && (newContext.userIdPartyHash || newContext.userCUCFijoHash || newContext.userCUCMovilHash || newContext.userCUCPrepagoHash)) || ""
      // logado light, titular sin geo
      if (!logged && newContext && newContext.userName && newContext.userName === 'Hola'){
        logged = true;
      }

       return {
        ...state,
        rehidrate: state.rehidrate + 1,
        logged,
        context: {
          ...newContext,
        },
      };
    }
    case types.SET_EDIT_MODE:{
      return {
        ...state,
        editMode: action.flag,
      }
    }
    default:
      return state;
  }
}

export default reducer;
